module.exports = __webpack_public_path__ + "assets/img/4.fb989b78.png";